/**
 * 获取支付方式工具类
 *
 * @author terrfly
 * @site https://www.techpayx.vip
 * @date 2021/5/8 07:18
 */

import config from '@/config'

const DEV_PAY_WAY_KEY = 'devPayWay'

const resolveDevPayWay = function () {
    try {
        const q = new URLSearchParams(window.location.search)
        const raw = q.get('devPayWay') || q.get('payWay')
        if (raw) {
            sessionStorage.setItem(DEV_PAY_WAY_KEY, raw)
        }
        const v = String(raw || sessionStorage.getItem(DEV_PAY_WAY_KEY) || '').toLowerCase()
        if (v === 'wx' || v === 'wxpay' || v === 'wx_jsapi') return config.payWay.WXPAY
        if (v === 'ali' || v === 'alipay' || v === 'ali_jsapi') return config.payWay.ALIPAY
        if (v === 'ysf' || v === 'ysfpay' || v === 'ysf_jsapi') return config.payWay.YSFPAY
    } catch (e) { /* ignore */ }
    return null
}

const getToPageRouteName = function () {
    const payWay = getPayWay();
    return  payWay ? payWay.routeName : null
}

const getPayWay = function () {
    const fromQuery = resolveDevPayWay()
    if (fromQuery) return fromQuery

    const userAgent = navigator.userAgent;
    if(userAgent.indexOf("MicroMessenger") >= 0){
        return config.payWay.WXPAY;
    }

    if(userAgent.indexOf("AlipayClient") >= 0){
        return config.payWay.ALIPAY;
    }

    if(userAgent.indexOf("unionpay") >= 0){
        return config.payWay.YSFPAY;
    }

    return null;
}

const getFixedRouteName = function () {
    const payWay = getPayWay();
    return payWay ? payWay.fixedRouteName : null;
}


export default {
    getToPageRouteName: getToPageRouteName,
    getPayWay: getPayWay,
    getFixedRouteName: getFixedRouteName
}
